// ✅ FINAL UPDATED MyCart WITH UOM QTY DROPDOWN + MRP AUTO AMOUNT + RAZORPAY SUPPORT
// import React, { useEffect, useState } from "react";
// import {
//   Typography,
//   Container,
//   Card,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Button,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   TextField,
//   Grid,
//   Box,
//   Snackbar,
//   CssBaseline,IconButton
// } from "@mui/material";
// import MuiAlert from "@mui/material/Alert";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";
// import Header3 from "../../Component/Header3";
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

// const getQtyOptions = (uom) => {
//   switch (uom) {
//     case 'Kg': return [30, 20, 15, 10, 5, 1, 0.5];
//     case 'G': return [10, 20, 30, 50, 100, 200, 300, 500, 750, 1000];
//     case 'Ltr': return [0.5, 1, 2, 5, 10, 15];
//     case 'Nos': return [1, 2, 3, 5, 6, 10, 12, 15, 20, 25];
//     default: return [];
//   }
// };

// const MyCart = () => {
//   const [selectedShop, setSelectedShop] = useState(null);
//   const [selectedProducts, setSelectedProducts] = useState([]);
//   const [packingOption, setPackingOption] = useState("Home Delivery");
//   const [address, setAddress] = useState("");
//   const [paymentMethod, setPaymentMethod] = useState("Cash on Delivery");
//   const [customerID, setCustomerID] = useState(null);
//   const [customerName, setCustomerName] = useState("");
//   const [customerAddress, setCustomerAddress] = useState("");
//   const [preferredAddress, setPreferredAddress] = useState("");
//   const [paymentStatus, setPaymentStatus] = useState();
//   const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
//   const [darkMode] = useState(prefersDarkMode);
//   const [customerMobile, setCustomerMobile] = useState();
//   const navigate = useNavigate();
//   const [toast, setToast] = useState({ open: false, message: "", severity: "success" });

//   const showToast = (message, severity = "success") => setToast({ open: true, message, severity });
//   const handleToastClose = (_, reason) => reason !== "clickaway" && setToast({ ...toast, open: false });

// useEffect(() => {
//   const shop = JSON.parse(sessionStorage.getItem("selectedShop"));
//   const products = JSON.parse(sessionStorage.getItem("selectedProducts"));

// if (shop && products && products.length > 0) {
//   setSelectedShop(shop);
//   setSelectedProducts(
//     products.map((p) => ({
//       ...p,
//       // Always start qty at 0 regardless of what's stored
//       quantity: 0,
//       // Start amount at 0 as well
//       amount: 0,
//     }))
//   );

//   console.log("Cart loaded successfully from sessionStorage (quantities reset to 0)");
// } else {
//    console.warn("🛒 No products found in session, redirecting to homepage");
//     navigate("/");
//   }
// }, []);

// // useEffect(() => {
// //   const shop = JSON.parse(sessionStorage.getItem("selectedShop"));
// //   const products = JSON.parse(sessionStorage.getItem("selectedProducts"));

// //   if (shop && products && products.length > 0) {
// //     setSelectedShop(shop);
// //   setSelectedProducts(
// //   products.map((p) => ({
// //     ...p,
// //     quantity: p.quantity ?? 0,
// //   }))
// // );

// //     console.log("Cart loaded successfully from sessionStorage");
// //   } else {
// //     console.warn("🛒 No products found in session, redirecting to homepage");
// //     navigate("/");
// //   }
// // }, []);

//   useEffect(() => {
//   const storedCustomerID = localStorage.getItem("customerId");
//   if (storedCustomerID) {
//     setCustomerID(storedCustomerID);
//     fetchCustomerCart(storedCustomerID);
//   } else {
//     navigate("/login");
//   }
// }, []);

//   const fetchCustomerCart = async (customerID) => {
//     try {
//       const res = await axios.get(`https://sakhisshop.com/api/customers/${customerID}`);
//       setCustomerName(res.data.customerName);
//       setCustomerAddress(res.data.address);
//       setPreferredAddress(res.data.preferredAddress);
//       setCustomerMobile(res.data.mobile);
//     } catch (e) {
//       console.error("❌ Error fetching customer details", e);
//     }
//   };

//  const handlePackingOptionChange = (e) => {
//   const val = e.target.value;
//   setPackingOption(val);
//   setAddress(
//     val === "Home Delivery"
//       ? customerAddress
//       : val === "Preferred Delivery"
//       ? preferredAddress
//       : "I will pick up"
//   );
// };

// const calculateTotal = () => {
//   return selectedProducts.reduce((sum, product) => sum + Number(product.amount || 0), 0);
// };

// const handlePlaceOrder = async () => {

//     // 🔒 (Temporarily disable Razorpay)
//   if (paymentMethod === "Cash on Delivery") {
//     setPaymentStatus("PENDING");
//     await placeOrder();
//   } else {
//     await handleOnlinePayment();
//   }
// };

// const handleOnlinePayment = async () => {
//   try {
//     const totalAmount = calculateTotal();
//     const shopkeeperId = selectedShop?.sID;

//     const { data } = await axios.post("https://sakhisshop.com/api/payments/createOrder", {
//       amount: totalAmount,
//       shopkeeperId,
//       currency: "INR",
//       customerID,
//     });

//     const options = {
//       key: data.key,
//       amount: data.amount.toString(),
//       currency: data.currency,
//       name: data.shopName || "Sakhi's Shop",
//       description: "Order Payment",
//       order_id: data.orderId,
//       prefill: {
//         name: customerName || "Customer",
//         contactNumber: customerMobile || "",
//       },
//       method: { upi: true, card: true, netbanking: true },
//       theme: { color: "#1976d2" },
//       flow: "auto",
//       handler: async (response) => {
//         try {
//           const verify = await axios.post("https://sakhisshop.com/api/payments/verifyPayment", {
//             orderId: response.razorpay_order_id,
//             paymentId: response.razorpay_payment_id,
//             signature: response.razorpay_signature,
//             shopkeeperId,
//           });

//           if (verify.status === 200) {
//             showToast("✅ Payment Successful!");
//             setPaymentStatus("PAID");
//             await placeOrder(); // Now place the order after successful payment
//           } else {
//             showToast("❌ Payment verification failed", "error");
//           }
//         } catch (err) {
//           showToast("❌ Payment failed during verification", "error");
//         }
//       },
//       modal: {
//         ondismiss: () => showToast("❌ Payment cancelled", "error"),
//       },
//     };

//     // ✅ UPI QR display for mobile devices
//     if (window.innerWidth < 768) {
//       options.config = {
//         display: {
//           blocks: {
//             qr: {
//               name: "Scan QR to Pay",
//               instruments: [{ method: "upi" }],
//             },
//           },
//           sequence: ["block.qr"],
//           preferences: {
//             show_default_blocks: false,
//           },
//         },
//       };
//     }

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   } catch (e) {
//     alert("Payment Failed! Please try again.");
//     console.error("Payment error:", e);
//   }
// };

// const placeOrder = async () => {
//   try {
//     const orderData = {
//      customerProfile: {
//     cID: customerID
//   },
//       customerName,
//       contactNumber: customerMobile,
//       shopProfile: { sID: selectedShop?.sID },
//       shopName: selectedShop?.shopname,
//       packingOption,
//       address,
//       paymentMethod,
//       paymentStatus,
//       totalAmount: calculateTotal(),
//       status: "Pending",
//       orderItems: selectedProducts.map((p) => ({
//         productName: p.productName,
//         mrp: p.mrp,
//         uom: p.uom,
//         quantity: p.quantity,
//        amount: p.amount,
//       customPrice: p.customPrice ?? p.mrp,
//       })),
//     };

//     const res = await axios.post("https://sakhisshop.com/api/orders/placeOrder", orderData);
//     showToast(`✅ Order placed! ID: ${res.data.orderID}`);
//     navigate(`/order-success/${res.data.orderID}`);
//   } catch (err) {
//     console.error("Order placement failed", err);
//     showToast("❌ Failed to place order", "error");
//   }
// };

// // 🎨 Theme setup (unchanged)
// const theme = createTheme({
//   palette: {
//     mode: darkMode ? "dark" : "light",
//     primary: { main: darkMode ? "#90caf9" : "#1976d2" },
//     background: {
//       default: darkMode ? "#121212" : "#f5f5f5",
//       paper: darkMode ? "#1e1e1e" : "#fff",
//     },
//   },
// });

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//         <Snackbar open={toast.open} autoHideDuration={3000} onClose={handleToastClose} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
//           <MuiAlert onClose={handleToastClose} severity={toast.severity} sx={{ width: "100%" }}>{toast.message}</MuiAlert>
//         </Snackbar>
//         <Header3 />

//         <Box sx={{ flex: 1, overflowY: "auto", py: 9 }}>
//           <Container maxWidth="md">
//             <Card sx={{ p: 3, boxShadow: 3, borderRadius: 3 }}>
//                <IconButton onClick={() => navigate(-1)} color="success">
//     <ArrowBackIosNewIcon  fontSize='large'/>
//   </IconButton>

//               <Typography variant="h4" align="center" color="primary" gutterBottom>My Cart</Typography>
//               {selectedShop && (
//                 <Box mb={2}>
//                   <Typography><b>Customer ID:</b> {customerID}</Typography>
//                   <Typography><b>Shop Name:</b> {selectedShop.shopname}</Typography>
//                 </Box>
//               )}
//               {selectedProducts.length > 0 && (
//                 <Table sx={{ mb: 2 }}>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell><b>Product</b></TableCell>
//                       <TableCell><b>MRP (₹)</b></TableCell>
//                       <TableCell><b>UOM</b></TableCell>
//                       <TableCell><b>Qty</b></TableCell>
//                       <TableCell><b>Amount (₹)</b></TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>

//                     {selectedProducts.map((product, i) => (

//                       <TableRow key={i}>
//                         <TableCell>{product.productName}</TableCell>
//                      <TableCell>{product.customPrice ?? product.mrp}</TableCell>

//                         <TableCell>{product.uom}</TableCell>
// <TableCell sx={{ minWidth: 100 }}>
//   <TextField
//     type="text"
//     size="small"
//     placeholder="Enter Qty"
// value={product.quantity ?? 0}
//    onChange={(e) => {
//       const input = e.target.value;

//       // Allow blank input
//       if (input === "") {
//         setSelectedProducts((prev) =>
//           prev.map((p) =>
//             p.id === product.id ? { ...p, quantity: "", amount: "" } : p
//           )
//         );
//         return;
//       }

//       // Allow only numeric input
//       const numericOnly = input.replace(/[^0-9.]/g, "");
//       const qty = parseFloat(numericOnly);
//       if (isNaN(qty)) return;

//       let calcAmount = qty;
//       if (product.uom === "G") {
//         calcAmount = qty / 1000; // gram to kg
//       }

//       const finalAmount = parseFloat(
//         calcAmount * (product.customPrice ?? product.mrp)
//       ).toFixed(2);

//       setSelectedProducts((prev) =>
//         prev.map((p) =>
//           p.id === product.id || p.productName === product.productName
//             ? {
//                 ...p,
//                 quantity: numericOnly,
//                 amount: finalAmount,
//               }
//             : p
//         )
//       );
//     }}
//     fullWidth
//     inputProps={{
//       inputMode: 'decimal',
//       style: {
//         textAlign: 'center',
//       },
//     }}
//     sx={{
//       '& input': {
//         padding: '8px',
//         textAlign: 'center',
//       },
//       '@media (max-width: 600px)': {
//         '& input': {
//           fontSize: '1rem',
//         },
//       },
//     }}
//   />
// </TableCell>
//                         <TableCell>{product.amount || 0}</TableCell>
//                       </TableRow>
//                     ))}
//                     <TableRow>
//                       <TableCell colSpan={4}><b>Total: ₹{calculateTotal().toFixed(2)}</b></TableCell>
//                       <TableCell><b>₹{calculateTotal()}</b></TableCell>
//                     </TableRow>
//                   </TableBody>
//                 </Table>
//               )}

//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6}>
//                   <FormControl fullWidth>
//                     <InputLabel>Packing Option</InputLabel>
//                     <Select value={packingOption} onChange={handlePackingOptionChange}>
//                       <MenuItem value="Home Delivery">Home Delivery</MenuItem>
//                       <MenuItem value="Preferred Delivery">Preferred Delivery</MenuItem>
//                       <MenuItem value="Pickup">I will Pick Up</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <TextField label="Delivery Address" fullWidth value={address} onChange={(e) => setAddress(e.target.value)} />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <FormControl fullWidth>
//                     <InputLabel>Payment Method</InputLabel>
//                     <Select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
//                       <MenuItem value="Cash on Delivery">Cash on Delivery</MenuItem>
//                       {/* <MenuItem value="Online Payment">Online Payment</MenuItem> */}
//                     </Select>
//                   </FormControl>
//                 </Grid>
//               </Grid>
//               <Box display="flex" justifyContent="center" mt={4}>
//                 <Button variant="contained" color="primary" size="large" onClick={handlePlaceOrder}>
//                   Place Order
//                 </Button>
//               </Box>
//             </Card>
//           </Container>
//         </Box>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default MyCart;

// import React, { useEffect, useState } from "react";
// import {
//   Typography,
//   Container,
//   Card,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Button,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   TextField,
//   Grid,
//   Box,
//   Snackbar,
//   CssBaseline,
//   IconButton,
//   Divider,
//   Paper,
// } from "@mui/material";
// import MuiAlert from "@mui/material/Alert";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";
// import Header3 from "../../Component/Header3";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// const MyCart = () => {
//   const [selectedShop, setSelectedShop] = useState(null);
//   const [selectedProducts, setSelectedProducts] = useState([]);
//   const [packingOption, setPackingOption] = useState("Home Delivery");
//   const [address, setAddress] = useState("");
//   const [paymentMethod, setPaymentMethod] = useState("Cash on Delivery");
//   const [customerID, setCustomerID] = useState(null);
//   const [customerName, setCustomerName] = useState("");
//   const [customerAddress, setCustomerAddress] = useState("");
//   const [preferredAddress, setPreferredAddress] = useState("");
//   const [paymentStatus, setPaymentStatus] = useState();
//   const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
//   const darkMode = false;
//   const [customerMobile, setCustomerMobile] = useState();
//   const navigate = useNavigate();
//   const [toast, setToast] = useState({ open: false, message: "", severity: "success" });

//   const showToast = (message, severity = "success") => setToast({ open: true, message, severity });
//   const handleToastClose = (_, reason) => reason !== "clickaway" && setToast({ ...toast, open: false });

//   useEffect(() => {
//     const shop = JSON.parse(sessionStorage.getItem("selectedShop"));
//     const products = JSON.parse(sessionStorage.getItem("selectedProducts"));

// //     //
// //     useEffect(() => {
// //   const savedProducts = JSON.parse(sessionStorage.getItem("selectedProducts")) || [];
// //   setSelectedProducts(savedProducts);
// // }, []);

//     if (shop && products && products.length > 0) {
//       setSelectedShop(shop);
//       setSelectedProducts(
//         products.map((p) => ({
//           ...p,
//           quantity: 0,
//           amount: 0,
//         }))
//       );
//     } else {
//       navigate("/");
//     }
//   }, []);

//   useEffect(() => {
//     const storedCustomerID = localStorage.getItem("customerId");
//     if (storedCustomerID) {
//       setCustomerID(storedCustomerID);
//       fetchCustomerCart(storedCustomerID);
//     } else {
//       navigate("/login");
//     }
//   }, []);

//   const fetchCustomerCart = async (customerID) => {
//     try {
//       const res = await axios.get(`https://sakhisshop.com/api/customers/${customerID}`);
//       setCustomerName(res.data.customerName);
//       setCustomerAddress(res.data.address);
//       setPreferredAddress(res.data.preferredAddress);
//       setCustomerMobile(res.data.mobile);
//     } catch (e) {
//       console.error("❌ Error fetching customer details", e);
//     }
//   };

//   const handlePackingOptionChange = (e) => {
//     const val = e.target.value;
//     setPackingOption(val);
//     setAddress(
//       val === "Home Delivery"
//         ? customerAddress
//         : val === "Preferred Delivery"
//         ? preferredAddress
//         : "I will pick up"
//     );
//   };

//   const calculateTotal = () => {
//     return selectedProducts.reduce((sum, product) => sum + Number(product.amount || 0), 0);
//   };

//   const handlePlaceOrder = async () => {
//     if (paymentMethod === "Cash on Delivery") {
//       setPaymentStatus("PENDING");
//       await placeOrder();
//     } else {
//       await handleOnlinePayment();
//     }
//   };

//   const handleOnlinePayment = async () => {
//     // (kept same as your logic)
//   };

//   const placeOrder = async () => {
//     try {
//       const orderData = {
//         customerProfile: { cID: customerID },
//         customerName,
//         contactNumber: customerMobile,
//         shopProfile: { sID: selectedShop?.sID },
//         shopName: selectedShop?.shopname,
//         packingOption,
//         address,
//         paymentMethod,
//         paymentStatus,
//         totalAmount: calculateTotal(),
//         status: "Pending",
//         orderItems: selectedProducts.map((p) => ({
//           productName: p.productName,
//           mrp: p.mrp,
//           uom: p.uom,
//           quantity: p.quantity,
//           amount: p.amount,
//           customPrice: p.customPrice ?? p.mrp,
//         })),
//       };

//       const res = await axios.post("https://sakhisshop.com/api/orders/placeOrder", orderData);
//       showToast(`✅ Order placed! ID: ${res.data.orderID}`);
//       navigate(`/order-success/${res.data.orderID}`);
//     } catch (err) {
//       console.error("Order placement failed", err);
//       showToast("❌ Failed to place order", "error");
//     }
//   };

//   // 🎨 Theme setup
//   const theme = createTheme({
//     palette: {
//       mode: darkMode ? "dark" : "light",
//       primary: { main: "#1976d2" },
//       background: {
//         default: darkMode ? "#121212" : "#f9fafb",
//         paper: darkMode ? "#1e1e1e" : "#ffffff",
//       },
//     },
//     typography: {
//       fontFamily: "Poppins, sans-serif",
//     },
//   });

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Header3 />
//       <Box sx={{ py: 10, px: { xs: 2, sm: 5 }, bgcolor: "background.default" }}>
//         <Container maxWidth="md">
//           <Card sx={{ p: { xs: 2, sm: 4 }, boxShadow: 4, borderRadius: 4 }}>
//             <Box display="flex" alignItems="center" mb={2}>
//               <IconButton onClick={() => navigate(-1)} color="primary">
//                 <ArrowBackIosNewIcon />
//               </IconButton>
//               <Typography variant="h5" fontWeight="bold" color="primary" ml={1}>
//                 My Cart
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 2 }} />

//             {selectedShop && (
//               <Box mb={2}>
//                 <Typography variant="body1">
//                   <b>Shop Name:</b> {selectedShop.shopname}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   <b>Customer ID:</b> {customerID}
//                 </Typography>
//               </Box>
//             )}

//             <Paper sx={{ width: "100%", overflowX: "auto", mb: 3 }}>
//               <Table>
//                 <TableHead sx={{ bgcolor: "primary.main" }}>
//                   <TableRow>
//                     {["Product", "MRP (₹)", "UOM", "Qty", "Amount (₹)", "Action"].map((head) => (

//                       <TableCell key={head} sx={{ color: "#fff", fontWeight: 600 }}>
//                         {head}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {selectedProducts.map((product, i) => (
//                     <TableRow key={i} hover>
//                       <TableCell>{product.productName}</TableCell>
//                       <TableCell>{product.customPrice ?? product.mrp}</TableCell>
//                       <TableCell>{product.uom}</TableCell>
//                       <TableCell>
//                         <TextField
//                           type="text"
//                           size="small"
//                           value={product.quantity ?? 0}
//                           placeholder="Enter Qty"
//                           onChange={(e) => {
//                             const input = e.target.value;
//                             if (input === "") {
//                               setSelectedProducts((prev) =>
//                                 prev.map((p) =>
//                                   p.id === product.id
//                                     ? { ...p, quantity: "", amount: "" }
//                                     : p
//                                 )
//                               );
//                               return;
//                             }
//                             const numericOnly = input.replace(/[^0-9.]/g, "");
//                             const qty = parseFloat(numericOnly);
//                             if (isNaN(qty)) return;

//                             let calcAmount = qty;
//                             if (product.uom === "G") calcAmount = qty / 1000;

//                             const finalAmount = parseFloat(
//                               calcAmount * (product.customPrice ?? product.mrp)
//                             ).toFixed(2);

//                             setSelectedProducts((prev) =>
//                               prev.map((p) =>
//                                 p.productName === product.productName
//                                   ? { ...p, quantity: numericOnly, amount: finalAmount }
//                                   : p
//                               )
//                             );
//                           }}
//                        fullWidth
//                         inputProps={{
//                           inputMode: "decimal",
//                           style: { textAlign: "center", fontSize: "0.9rem" },
//                         }}
//                         sx={{
//                           width: { xs: "70px", sm: "100px" }, // 👈 Responsive width
//                           "& .MuiInputBase-input": {
//                             padding: "6px 4px", // 👈 Compact padding for mobile
//                           },
//                         }}
//                       />
//                       </TableCell>
//                       <TableCell>{product.amount || 0}</TableCell>
//                       <TableCell>
//                     <Button
//                       color="error"
//                       onClick={() => {
//                         setSelectedProducts((prev) =>
//                           prev.filter((p) => p.productName !== product.productName)
//                         );
//                         sessionStorage.setItem(
//                           "selectedProducts",
//                           JSON.stringify(
//                             selectedProducts.filter((p) => p.productName !== product.productName)
//                           )
//                         );
//                       }}
//                     >
//                       ❌
//                     </Button>
//                   </TableCell>
//                     </TableRow>
//                   ))}
//                   <TableRow sx={{ bgcolor: "#f4f6f8" }}>
//                     <TableCell colSpan={4} align="right">
//                       <Typography fontWeight="bold">Total:</Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography fontWeight="bold" color="primary">
//                         ₹{calculateTotal().toFixed(2)}
//                       </Typography>
//                     </TableCell>
//                   </TableRow>
//                 </TableBody>
//               </Table>
//             </Paper>

//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>Packing Option</InputLabel>
//                   <Select value={packingOption} onChange={handlePackingOptionChange}>
//                     <MenuItem value="Home Delivery">Home Delivery</MenuItem>
//                     <MenuItem value="Preferred Delivery">Preferred Delivery</MenuItem>
//                     <MenuItem value="Pickup">I will Pick Up</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   label="Delivery Address"
//                   fullWidth
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>Payment Method</InputLabel>
//                   <Select
//                     value={paymentMethod}
//                     onChange={(e) => setPaymentMethod(e.target.value)}
//                   >
//                     <MenuItem value="Cash on Delivery">Cash on Delivery</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>
//             <Box textAlign="center" mt={2}>
//               <Button
//                 variant="outlined"
//                 color="primary"
//                 sx={{ mb: 2 }}
//                 onClick={() => navigate("/customer-dashboard")}
//               >
//                 ➕ Add More Items
//               </Button>
//             </Box>
//             <Box textAlign="center" mt={4}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 size="large"
//                 sx={{
//                   px: 5,
//                   py: 1.5,
//                   fontWeight: "bold",
//                   borderRadius: 2,
//                   boxShadow: 2,
//                   "&:hover": { boxShadow: 4 },
//                 }}
//                 onClick={handlePlaceOrder}
//               >
//                 Place Order
//               </Button>
//             </Box>
//           </Card>
//         </Container>
//       </Box>

//       <Snackbar
//         open={toast.open}
//         autoHideDuration={3000}
//         onClose={handleToastClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <MuiAlert onClose={handleToastClose} severity={toast.severity} sx={{ width: "100%" }}>
//           {toast.message}
//         </MuiAlert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// };

// export default MyCart;

// New UI Developmetn code  checkout screenCart 13 march 26
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Divider,
} from "@mui/material";
import axios from "axios";
import Header3 from "../../Component/Header3";

const baseUrl = "https://sakhisshop.com";

function MyCart() {
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");

  const [shopname, setShopname] = useState("");
  const [address, setAddress] = useState("");
  const [shopId, setShopId] = useState(0);

  const [totalAmount, setTotalAmount] = useState(0);
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart") || "[]");
    setCart(savedCart);

    setShopname(localStorage.getItem("shopName") || "");
    setAddress(localStorage.getItem("shopAddress") || "");
    setShopId(parseInt(localStorage.getItem("selectedShopId")) || 0);
  }, []);

  useEffect(() => {
    const total = cart.reduce((sum, item) => {
      return sum + item.price * item.quantity;
    }, 0);
    setTotalAmount(total);
  }, [cart]);

  const deleteItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1);
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
  };

  const generateOrder = async () => {
    try {
      const customerId = localStorage.getItem("customerId");

      const orderItems = cart.map((item) => ({
        productName: item.productName,
        quantity: item.quantity,
        uom: item.uom || "kg",
        mrp: item.price,
        customPrice: item.price,
      }));

      const payload = {
        customerName: name,
        contactNumber: mobile,
        paymentMethod: "Cash on Delivery",
        packingOption: "Home Delivery",
        customerProfile: { cID: parseInt(customerId) },
        shopProfile: { sID: shopId },
        orderItems: orderItems,
      };

      const res = await axios.post(`${baseUrl}/api/orders/placeOrder`, payload);

      const orderId = res.data.orderID;

      localStorage.removeItem("cart");

      window.location.href = `/order-success/${orderId}`;
    } catch (e) {
      alert("Order failed");
    }
  };

  return (
    <Box sx={{ maxWidth: "900px", mx: "auto", p: 7 }}>
      <Header3 />

      {/* SHOP CARD */}
      <Card sx={{ mb: 3, borderRadius: "16px", boxShadow: 4 }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold">
            {shopname || "Shop Name"}
          </Typography>
          <Typography color="text.secondary">
            {address || "Shop Address"}
          </Typography>
        </CardContent>
      </Card>

      {/* CART ITEMS */}
      <Typography variant="h6" mb={2}>
        🛒 Your Cart
      </Typography>

      <Grid container spacing={2}>
        {cart.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Card sx={{ borderRadius: "12px", boxShadow: 2 }}>
              <CardContent>
                <Grid container alignItems="center">
                  <Grid item xs={8}>
                    <Typography fontWeight="bold">
                      {item.productName}
                    </Typography>

                    <Typography color="green">
                      ₹{item.price} × {item.quantity}
                    </Typography>
                  </Grid>

                  <Grid item xs={4} textAlign="right">
                    <Button color="error" onClick={() => deleteItem(index)}>
                      Remove
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* CUSTOMER */}
      <Card sx={{ mt: 3, p: 2, borderRadius: "16px" }}>
        <Typography variant="h6">Customer Details</Typography>

        <TextField
          fullWidth
          label="Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          sx={{ mt: 2 }}
        />

        <TextField
          fullWidth
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: 2 }}
        />
      </Card>

      {/* TOTAL */}
      <Card sx={{ mt: 3, p: 2, borderRadius: "16px" }}>
        <Typography>Subtotal: ₹{totalAmount.toFixed(2)}</Typography>
        <Typography>Tax (5%): ₹{(totalAmount * 0.05).toFixed(2)}</Typography>

        <Divider sx={{ my: 1 }} />

        <Typography variant="h6" fontWeight="bold">
          Total: ₹{(totalAmount * 1.05).toFixed(2)}
        </Typography>
      </Card>

      {/* BUTTON */}
      <Button
        fullWidth
        onClick={generateOrder}
        sx={{
          mt: 3,
          height: "50px",
          background: "linear-gradient(45deg, #6a1b9a, #8e24aa)",
          color: "#fff",
          fontSize: "16px",
          borderRadius: "12px",
        }}
      >
        Place Order 🚀
      </Button>
    </Box>
  );
}

export default MyCart;
